import React from "react";
import { useTinyHost } from "@tiny/host-contract";

export default function useStringParam<T = string>(
  name: string
): [T | undefined, (value?: T, mode?: "push" | "replace") => void];
export default function useStringParam<T = string>(
  name: string,
  defaultValue: T
): [T, (value?: T, mode?: "push" | "replace") => void];
export default function useStringParam<T = string>(
  name: string,
  defaultValue?: T
) {
  const { navigate } = useTinyHost();
  const search = navigate.getSearch?.() ?? "";
  const pathname = navigate.getPathname?.() ?? "";

  const param = React.useMemo(() => {
    const urlSearchParams = new URLSearchParams(search);
    return urlSearchParams.get(name) || defaultValue;
  }, [defaultValue, name, search]);

  const setParam = React.useCallback(
    (value?: string, mode?: "push" | "replace") => {
      const urlSearchParams = new URLSearchParams(search);
      if (value) {
        urlSearchParams.set(name, value);
      } else {
        urlSearchParams.delete(name);
      }
      const url = `${pathname}?${urlSearchParams.toString()}`;
      if (mode === "push") {
        navigate.to(url);
      } else {
        navigate.replace(url);
      }
    },
    [navigate, name, pathname, search]
  );

  return [param, setParam];
}
